module.exports = __webpack_public_path__ + "img/kr.2832b73a.svg";